<template>
  <div class="main main--customers">
    <div class="main__title main__title--3row">
      <h2>單元 {{ sections[0].sectionOrder }} </h2>
      <div  @click="fjfj()">完成單元
      </div>
    </div>
    <div class="courseContent">
      <div class="courseContent__image">
        <video width="100%" controls>
          <source :src="sections[0].sectionVideo" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div class="courseContent__title">
        <h3>單元名稱</h3>
        <div>{{ sections[0].sectionName }}</div>
      </div>
      <div class="courseContent__intro">
        <h3>單元內容</h3>
        <div>{{ sections[0].sectionFile }}</div>
      </div>
    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('@/firebaseConfig.js')

export default {
  computed: {
    ...mapState(['onlineCourse'])
  },
  created () {
    const sectionId = this.$route.path.split('/').pop()
    const courseId = this.$route.path.split('/')[this.$route.path.split('/').length - 2]
    let result = {}
    this.onlineCourse.forEach(course => {
      if (course.remedialId === courseId) {
        result = course
      }
    })
    this.hha = result
    fb.db.collection('onlinecourse').doc(courseId).collection('courseSection').get().then(querySnapshot => {
      let customersArray = []
      querySnapshot.forEach(doc => {
        let customer = doc.data()
        customer.id = doc.id
        if (doc.id === sectionId) {
          customersArray.unshift(customer)
        }
      })
      this.sections = customersArray
    })
  },
  data () {
    return {
      reviewCourses: [
        {}, {}
      ],
      haa: {},
      sections: [],
      section: {}
    }
  },
  methods: {
    fjfj () {
      let thisName = this.$route.path.split('/')
      thisName.pop()
      const result = thisName.join('/')
      this.$router.push({ path: result })
    }
  }
}
</script>

<style lang="scss" scoped>
.courseContent {
  font-size: 18px;
  .courseContent__image {
    width: 100%;
    height: auto;
  }
  .courseContent__title {
    padding: 2rem;
    h3 {
      font-size: 1.5em;
      margin-bottom: 1rem;
    }
  }
  .courseContent__intro {
    background: #f9f9f9;
    padding: 2rem;
    h3 {
      margin-bottom: 1rem;
    }
  }
  .courseContent__unit {
    padding: 2rem;
    h3 {
      margin-bottom: 1rem;
    }
    .unit-list__item {
      display: grid;
      grid-template-columns: 1fr 8fr 1fr;
      font-weight: 700;
        .grey {
          color: #333;
        }
      }
    }
}
</style>
